module.exports = __webpack_public_path__ + "static/media/carroussel_08.f6e83167.jpg";